import { react } from "uikit";
import { Dispatch } from "react";

import CompaniesAndTaxiServices from ".";

interface Context {
	value: CompaniesAndTaxiServices.Value;
	setError: Dispatch<boolean>;
	required: boolean;
}

export default class Controller extends react.ControllerBase<Context> {
	validate() {
		const isValid = !!this.context?.value.companyIds.length;
		const required = this.context?.required;

		if (!required) return true;
		if (!isValid) this.context?.setError(true);

		return isValid;
	}
}
